import { CompanyIcon } from '../enums';
import { UserType } from '../types';

export const DEFAULT_USER_DATA: UserType = {
  id: process.env.REACT_APP_HOME_PAGE_USER_ID || '',
  firstName: 'Mike',
  lastName: 'Gutierrez',
  location: 'Portland, OR',
  image: 'https://d2pviryyz9qcvf.cloudfront.net/IMG_1066.jpeg',
  intro: {
    title: 'Hello!',
    headline: `I'm Mike Gutierrez, a web engineer located in Portland, Oregon
      specialized in full-stack systems & AI workflows.`,
    tagline: 'Currently open to new opportunities.',
    experienceSectionCallToAction: 'Explore work',
  },
  experience: [
    {
      title: 'Senior Software Engineer',
      companyName: 'Microsoft · Contract',
      dates: 'Nov 2024 - Present',
      technologies: [
        'Deterministic LLM Programming',
        'Azure AI Foundry',
        'TypeScript',
        'Next.js',
        'REST APIs',
        'Azure DevOps Pipelines',
        'Accessibility (A11y)',
        'Design Systems',
        'Zod',
      ],
      icon: CompanyIcon.MICROSOFT,
      order: 6,
    },
    {
      title: 'Senior Software Engineer',
      companyName: 'Apple · Contract',
      dates: 'Nov 2023 - Nov 2024',
      technologies: [
        'React.js',
        'ES6',
        'SQL',
        'Relational Databases',
        'REST APIs',
        'Kubernetes',
        'Unit Testing',
        'Continuous Integration and Continuous Delivery (CI/CD)',
        'JavaScript',
        'CSS3',
        'HTML 5',
      ],
      icon: CompanyIcon.APPLE,
      order: 5,
    },
    {
      title: 'Senior Software Engineer',
      companyName: 'Rivian',
      dates: 'Oct 2021 - Apr 2023',
      technologies: [
        'React.js',
        'TypeScript',
        'GraphQL',
        'JavaScript',
        'Unit Testing',
        'Continuous Integration and Continuous Delivery (CI/CD)',
        'AWS Lambda',
        'AWS AppSync',
        'AWS Dynamodb',
        'Serverless Framework',
        'Python',
        'CSS3',
        'HTML 5',
        'Material-UI',
        'Git',
        'Figma',
      ],
      icon: CompanyIcon.RIVIAN,
      order: 4,
    },
    {
      title: 'Software Engineer II',
      companyName: 'Supergroup™',
      dates: 'Feb 2019 - Oct 2021',
      technologies: [
        'React.js',
        'TypeScript',
        'GraphQL',
        'JavaScript',
        'Node.js',
        'Express.js',
        'Unit Testing',
        'REST APIs',
        'CSS3',
        'HTML 5',
        'Material-UI',
        'Git',
        'Contentful',
        'Shopify',
        'Zeplin',
      ],
      icon: CompanyIcon.SUPERGROUP,
      images: [
        'https://d2pviryyz9qcvf.cloudfront.net/portfolio/AngelCity_5.png',
      ],
      order: 3,
    },
    {
      title: 'Software Engineer',
      companyName: 'UpKeep',
      dates: 'May 2018 - Feb 2019',
      technologies: [
        'React.js',
        'GraphQL',
        'JavaScript',
        'Node.js',
        'Redux',
        'Express.js',
        'LESS',
        'CSS3',
        'HTML 5',
        'Git',
      ],
      icon: CompanyIcon.UPKEEP,
      images: ['https://d2pviryyz9qcvf.cloudfront.net/portfolio/UpKeep_1.jpg'],
      order: 2,
    },
    {
      title: 'Software Engineer',
      companyName: 'SteelHouse',
      dates: 'Apr 2013 - Mar 2017',
      technologies: [
        'React.js',
        'GraphQL',
        'JavaScript',
        'Node.js',
        'Redux',
        'Express.js',
        'LESS',
        'CSS3',
        'HTML 5',
        'jQuery',
        'Git',
        'Ad Tech',
      ],
      icon: CompanyIcon.STEELHOUSE,
      images: [
        'https://d2pviryyz9qcvf.cloudfront.net/portfolio/SteelHouse_AdSuite.jpg',
      ],
      order: 1,
    },
  ],
  about: {
    headline: `Over the past ten years I've learned that writing great software
      requires not only strong systems thinking, but also core
      strengths in areas of deep interest.`,
    subheading: `This is why I focus on full-stack architecture and workflow-driven UI, 
      combining reliable APIs, CI/CD discipline, and practical AI agent systems to ship 
      software that holds up in real environments.`,
    coreSkills: [
      'Typescript',
      'React',
      'Node.js',
      'GraphQL',
      'AI Tooling',
      'AWS & Azure',
      'CI/CD',
      'Testing',
    ],
  },
};
